<template>
    <v-autocomplete
    v-model="selectedProducts"
    :items="products"
    :label="deckSelectorLabel"
    item-value="name"
    item-text="name"
    return-object
    multiple
    chips
    deletable-chips>
      <template #selection="{item}">
        <v-chip close @click:close="selectedProducts = selectedProducts.filter(sp => sp.productId !== item.productId)">
          <span style="overflow: hidden;">
            {{ item.name }}
          </span>
        </v-chip>
      </template>
      <template #item="{item}">
        {{ item.name }}
      </template>
      <template #append>
        <Icon
        icon="mdi-lock-plus"
        iconColor="black"
        :small="false"
        :tooltipText="$t('restrictToCurrentProducts')"
        :disabled="productIdsOnDeck.length === 0"
        @icon-clicked="getProductsOnDeck()"
        />
      </template>
    </v-autocomplete>
  </template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ProductSelector',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    propProducts: {
      type: Array,
      default: undefined
    },
    includeByproducts: {
      type: Boolean,
      default: true
    },
    includeLogsProducts: {
      type: Boolean,
      default: true
    },
    excludeProductIds: {
      type: Array,
      default: undefined
    },
    locationId: {
      type: Number,
      default: undefined
    },
    deckId: {
      type: Number,
      default: undefined
    },
    productIdsOnDeck: {
      type: Array,
      default: undefined
    }
  },

  data: () => ({
    products: [],
    selectedProducts: []
  }),

  computed: {
    deckSelectorLabel () {
      return this.selectedProducts.length === 0 ? this.$t('acceptsAllProducts') : this.$t('restrictedTo')
    }
  },

  watch: {
    selectedProducts: {
      handler (val) {
        this.$emit('products-selected', val)
      },
      deep: true
    },

    includeByproducts: {
      async handler (_) {
        await this.getProducts()
      }
    }
  },

  created () {
    this.getProducts()
  },

  methods: {
    ...mapActions('product', ['fetchProducts']),
    async getProducts () {
      this.products = await this.fetchProducts({ includeByProducts: this.includeByproducts, includeProduction: this.includeLogsProducts })

      if (!this.propProducts || this.propProducts.length === 0) return
      this.products.forEach(p => {
        const isProp = this.propProducts.some(id => id === p.productId)
        const isSelected = this.selectedProducts.some(id => id === p.productId)
        if (isProp && !isSelected) {
          this.selectedProducts.push(p)
        }
      })
    },

    getProductsOnDeck () {
      if (this.productIdsOnDeck.length === 0) return
      this.products.forEach(p => {
        const isPresentOnDeck = this.productIdsOnDeck.some(id => id === p.productId)
        if (isPresentOnDeck) {
          if (!this.isAlreadySelected(p.productId)) {
            this.selectedProducts.push(p)
            this.propProducts.push(p)
          }
        }
      })
    },

    isAlreadySelected (productId) {
      return this.selectedProducts.some(product => product.productId === productId)
    }
  }
}
</script>
